import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';

import { AlertTypeEnum } from '../../models/enums/alert-type.enum';

@Component({
    selector: 'sl-alert',
    templateUrl: './alert.component.html',
    styleUrls: ['./alert.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AlertComponent implements OnInit {
    @Input() text: string;
    @Input() canClose = true;
    @Input() isTranslated = false;
    @Input() type = AlertTypeEnum.Warning;

    showAlert = true;
    extraClass = '';

    ngOnInit(): void {
        this.setupExtraClass();
    }

    private setupExtraClass(): void {
        if (this.type === AlertTypeEnum.Warning) {
            return;
        }

        switch (this.type) {
            case AlertTypeEnum.Error:
                this.extraClass = 'error';
                break;
            case AlertTypeEnum.Info:
                this.extraClass = 'info';
                break;
            case AlertTypeEnum.Success:
                this.extraClass = 'success';
                break;
            default:
                break;
        }
    }
}
